<template>
  <div class="pt-4 pb-24 px-4">
    <SelectSignals :title="$t('signals')" />
  </div>

  <TransitionRoot as="template" :show="openConfirmDisableTrade">
    <Dialog class="relative z-50" @close="cancelToggleAllSignals">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      <div class="fixed inset-0 z-50 flex items-end justify-center">
        <TransitionChild
            as="template"
            enter="transform transition ease-in-out duration-300"
            enter-from="translate-y-full opacity-0"
            enter-to="translate-y-0 opacity-100"
            leave="transform transition ease-in-out duration-300"
            leave-from="translate-y-0 opacity-100"
            leave-to="translate-y-full opacity-0"
        >
          <DialogPanel class="w-full bg-white rounded-t-2xl px-4 pt-5 pb-4 text-left shadow-xl sm:max-w-lg sm:w-full sm:p-6">
            <div>
              <div class="mt-3 text-center sm:mt-5">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  {{
                    confirmDisableAll
                        ? $t('confirm_disable_all_signals')
                        : $t('confirm_enable_all_signals')
                  }}
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-600">
                    {{
                      confirmDisableAll
                          ? $t('are_you_sure_you_want_to_disable_all_signals')
                          : $t('are_you_sure_you_want_to_enable_all_signals')
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-6 sm:flex sm:flex-row-reverse">
              <button
                  @click="confirmToggleAllSignals"
                  type="button"
                  class="w-full inline-flex justify-center rounded-xl border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white"
                  :class="[$theme.inverseBaseBg]"
              >
                {{ $t('confirm') }}
              </button>
              <button
                  @click="cancelToggleAllSignals"
                  type="button"
                  class="mt-3 w-full inline-flex justify-center rounded-xl border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              >
                {{ $t('cancel') }}
              </button>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { addBackButton, hideBackButton } from "@/helpers/telegramHelper";
import { capitalizeFirstLetter } from "@/helpers/stringHelper";
import SelectSignals from "@/components/settings/SelectSignals.vue";

export default {
  components: {
    SelectSignals,
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
  },

  data() {
    return {
      loading: true,
      signalEnabled: [],
      signals: [],
      error: null,
      openConfirmDisableTrade: false,
      confirmDisableAll: false,
      capitalizeFirstLetter,
      user: null,

      filtersByTypeAsset: [
        {
          name: 'USDT',
          key: 'USDT',
        },
        {
          name: 'USDC',
          key: 'USDC',
        },
      ],

      filters: {
        activeTypeAsset: 'USDT'
      }
    };
  },

  computed: {
    tariffSignals() {
      return this.user?.tariff?.signals ?? [];
    },

    isMexc() {
      return (
          this.user?.tariff?.tariff?.exchanges &&
          this.user.tariff.tariff.exchanges.indexOf('mexc') !== -1
      );
    },

    allowedSignalsIds() {
      if (this.user?.tariff?.signals && this.user.tariff.signals.length > 0) {
        return this.user.tariff.signals.map((signal) => signal.id);
      } else {
        return this.signals.map((signal) => signal.id);
      }
    },

    isAllSignalsDisabled() {
      return this.allowedSignalsIds.every(
          (id) => !this.signalEnabled.includes(id)
      );
    },
  },

  methods: {
    renderTariffNames(tariffs) {
      return tariffs.map((tariff) => " - " + tariff.title).join("<br>");
    },

    toggleDisableAllSignals(event) {
      event.preventDefault();
      if (!this.isAllSignalsDisabled) {
        // Пользователь хочет отключить все сигналы
        this.confirmDisableAll = true;
      } else {
        // Пользователь хочет включить все сигналы
        this.confirmDisableAll = false;
      }
      this.openConfirmDisableTrade = true;
    },

    confirmToggleAllSignals() {
      if (this.confirmDisableAll) {
        // Отключаем все сигналы
        this.signalEnabled = [];
      } else {
        // Включаем все разрешённые сигналы
        this.signalEnabled = [...this.allowedSignalsIds];
      }
      this.updateUserSettings();
      this.openConfirmDisableTrade = false;
    },

    cancelToggleAllSignals() {
      this.openConfirmDisableTrade = false;
    },

    toggleSignal(id) {
      const index = this.signalEnabled.indexOf(id);
      if (index === -1) {
        this.signalEnabled.push(id);
      } else {
        this.signalEnabled.splice(index, 1);
      }
      this.updateUserSettings();
    },

    updateUserSettings() {
      this.$api
          .post("/user/update-settings", {
            signals: this.signalEnabled,
          })
          .then((result) => {
            console.log("Settings updated.", result.data.signals);
            this.$store.commit('updateEnabledSignals', result.data.signals);
          })
          .catch((e) => {
            console.error(e);
            this.error = e;
          });
    },

    onChangeTypeAsset(type) {
      this.filters.activeTypeAsset = type;
      this.loadSignals();
    },

    loadSignals() {
      this.loading = true;

      this.$api.get('/signals', {
        params: {
          type_asset: this.filters.activeTypeAsset
        }
      }).then((result) => {
        this.signals = result.data;
        this.loading = false;
      }).catch((e) => {
        console.error(e);
        this.error = e;
        this.loading = false;
      });
    },

    loadUser() {
      this.$api
          .get("/user")
          .then((result) => {
            this.user = result.data.data;
            this.signalEnabled = this.user.settings.signals;
          })
          .catch((e) => {
            console.error(e);
            this.error = e;
          });
    },
  },

  mounted() {
    this.loadUser();
    this.loadSignals();
    addBackButton(this.$router);
  },

  beforeUnmount() {
    hideBackButton();
  },
};
</script>
